import { gql } from '@apollo/client';

export const DELETE_LEAD_SIMULATIONS_MUTATION = gql`
  mutation DeleteLeadSimulations($leadId: ID!) {
    deleteLeadSimulations(leadId: $leadId)
  }
`;
